import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme, _props: unknown, classes: Record<"tableRow" | "tableCell" | "trashCan", string>) => {
	return {
		tableRow: {
			transition: ".1s",
			borderTop: "1px solid lightgray",
			borderBottom: "1px solid lightgray",
			transform: "none",
			"&:hover": {
				backgroundColor: "#f7f7f7",
				[`& .${classes.trashCan}`]: {
					color: "darkgray",
					"&:hover": {
						color: "gray"
					}
				}
			},
			"&:focus": {
				backgroundColor: "#f7f7f7",
			}
		},
		tableCell: {
			minWidth: "100px",
			maxWidth: "100px"
		},
		trashCan: {
			transition: ".1s",
			cursor: "pointer",
			color: "transparent",
		},
	} satisfies Record<string, CSSObject>;
};
